
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {addIntegration, fetchIntegrations} from 'redux/modules/integrations/actions'
import PromptContainer from 'components/PromptContainer'
import FormInput from 'components/FormInput'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import ButtonsGroup from 'components/ButtonsGroup'
import {channelGroups as groups} from '@divvit/common-channels'

export class IntegrationsNewSpreadsheet extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    initialize: PropTypes.func,
    channel: PropTypes.object,
    merchantSite: PropTypes.object
  }

  constructor(props) {
    super(props)
    const {
      initialize,
      merchantSite,
      channel: {channelGroupId, channelId}
    } = props

    const groupName = groups[channelGroupId].label
    const channelName = groups[channelGroupId].channels[channelId].label

    initialize({
      name: `Data-Driven costs (${groupName}/${channelName}, ${merchantSite.name})`
    })
  }

  render() {
    const {
      handleSubmit,
      invalid,
      submitting,
      closeModal
    } = this.props

    return (
      <PromptContainer className='report-add-view' title='Create Google Spreadsheet'>
        <form onSubmit={handleSubmit}>
          <Field
            className='manual-integration_form_input'
            name='name'
            disabled={submitting}
            label='Spreadsheet name'
            component={FormInput}
          />
          <ButtonsGroup className='manual-integration_actions' align='right'>
            <button
              className='button is-transparent manual-integration_action'
              type='button'
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              type='submit'
              className='button manual-integration_action manual-integration_form_submit'
              disabled={submitting || invalid}
            >
                Create spreadsheet
            </button>
          </ButtonsGroup>
        </form>
      </PromptContainer>
    )
  }
}

const mapStateToProps = (state, {currentSite}) => {
  return {merchantSite: currentSite}
}

export default connect(mapStateToProps, {
  closeModal
})(reduxForm({
  form: 'integrationsNewSpreadsheet',
  touchOnChange: true,
  validate: ({name}) => {
    const errors = {}

    if (!name) {
      errors.name = 'Please provide spreadsheet name1'
    }

    return errors
  },
  onSubmit: ({name}, dispatch, {channel, currentSite}) => new Promise((resolve, reject) => {
    dispatch(addIntegration('google-spreadsheet', {name, channel, merchantSiteId: currentSite.id}))
      .success(() => {
        dispatch(closeModal())
        dispatch(fetchIntegrations())
        resolve()
      })
      .fail(err => {
        dispatch(closeModal())
        reject(new SubmissionError({_error: err}))
      })
  })
})(IntegrationsNewSpreadsheet))



// WEBPACK FOOTER //
// ./client/modals/IntegrationsNewSpreadsheet/index.js